import axios from 'axios';
import { baseUrl } from '@/config';
import forEach from 'lodash/forEach';

export default {
  /**
   * 선택한 차트 템플릿 정보를 조회한다.
   * @author Ju
   * @param  {String} templateSeq [템플릿 시퀜스 번호]
   * @return {[type]}        [description]
   */
  getPerfChartTemplate(templateSeq) {
    return axios.get(`${baseUrl}/chart/get-perf-chart-tempate.do`, { params: { templateSeq } });
  },
  /**
   * 관리대상의 자원 정보를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getChartRscInfo(params) {
    return axios.post(`${baseUrl}/chart/get-chart-rsc-info.do`, params);
  },
  getForecastPerfClusterData(params) {
    return axios.post(`${baseUrl}/machine/get-performance-cluster-data.do`, params);
  },
  /**
   * 새로운 차트 템플릿을 저장한다.
   * @param  {[type]} params [description]
   * @author jda
   */
  addPerfChartTemplate(params) {
    return axios.post(`${baseUrl}/chart/add-perf-chart-template.do`, params);
  },
  /**
   * 차트 템플릿 이름을 변경한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  updatePerfChartTemplate(params) {
    return axios.post(`${baseUrl}/chart/update-perf-chart-template.do`, params);
  },
  /**
   * 사용자별 차트 템플릿 리스트를 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getPerfChartTemplateByManager() {
    return axios.get(`${baseUrl}/chart/get-perf-chart-template-by-manager.do`);
  },
  /**
   * 자원 구분키를 조회한다.
   * @return {[type]} [description]
   * @author jda
   */
  getObjRscKeys(params) {
    return axios.post(`${baseUrl}/chart/get-obj-rsc-keys.do`, params);
  },
  /**
   * managetypeId, objId, rsctypeId, rscId를 이용하여 자원 구분키 리스트를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getRscKeyByRscInfo(params) {
    return axios.post(`${baseUrl}/chart/get-rsc-keys-by-rsc-info.do`, params);
  },
  /**
   * [Smart분석]의 예측 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSmartForecasData(params) {
    return axios.post(`${baseUrl}/smart/get-forecast-performance-data.do`, params);
  },
  /**
   * [Smart 분석]의 상관분석 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSmartCorrelationData(params) {
    return axios.post(`${baseUrl}/smart/get-correlation-data.do`, params);
  },
  /**
   * [Smart 분석]의 임계치 가이드 데이터를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getSmartBoundaryData(params) {
    return axios.post(`${baseUrl}/smart/get-cluster-plot-data.do`, params);
  },
  /**
   * 차트 템플릿을 삭제한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  deletePerfChartTemplate(params) {
    return axios.get(`${baseUrl}/chart/delete-perf-chart-template.do`, { params });
  },
  /**
   * 차트 템플릿의 엑셀 출력
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  exportChartExcel(params) {
    const form = document.createElement('form');
    form.action = `${baseUrl}/chart/export-chart-excel.do`;
    form.method = 'post';
    forEach(params, (value, key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', value);
      form.appendChild(hiddenField);
    });
    document.body.appendChild(form);
    form.submit();

    document.body.removeChild(form);
  },
  /**
   * 실시간 성능 데이터 정보를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getRealtimeResourceData(params, datetime) {
    return axios.post(`${baseUrl}/chart/get-realtime-resource-data.do?datetime=${datetime}`, params);
  },
  /**
   * 예측분석 설정을 저장한다
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  saveAlgorithmSetting(params) {
    return axios.post(`${baseUrl}/smart/save-algorithm-setting.do`, params);
  },
  /**
   * 알고리즘 옵션 선택 시 해당 설정값 로드
   * @author leesy918
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  selectAlgorithmOption(params) {
    return axios.post(`${baseUrl}/smart/select-algorithm-forecast-performance-data.do`, params);
  },
  /**
   * 알고리즘 메뉴 로드
   * @author leesy918
   * @return {[type]} [description]
   */
  getAlgorithmMenu() {
    return axios.get(`${baseUrl}/smart/get-forecast-performance-algorithm-menu.do`);
  },
  /**
   * hashkeyId로 forecast learning set 로드
   * @author Minyeong
   * @param  {[type]} params [hashkeyId]
   * @return {[type]}        [description]
   */
  getForecastLearningSet(params) {
    return axios.post(`${baseUrl}/smart/get-forecast-learning-set.do`, params);
  },
  /**
   * 성능 차트의 실시간 데이터(시리즈)를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author hwang
   */
  getPerformanceChartRawData(params, config) {
    return axios.post(`${baseUrl}/chart/get-performance-analysis-chart-raw-data.do`, params, config);
  },
};



// WEBPACK FOOTER //
// ./src/api/chart/chart-analysis.js